import React from "react";
import classNames from "classnames";
import './project-card.css'

class ProjectCard extends React.Component {
    get className() {
        return classNames(this.props.className, "project-card");
    }

    formatStatus(status) {
        switch (status) {
            case 'LIVE':
                return 'Live';
            case 'IN_DEVELOPMENT':
                return 'In Development';
            case 'PLANNING':
                return 'Planning';
            case 'COMPLETED':
                return 'Completed';
            case 'ON_HOLD':
                return 'On Hold';
            default:
                return status;
        }
    }

    getStatusClass(status) {
        switch (status) {
            case 'LIVE':
                return 'live';
            case 'IN_DEVELOPMENT':
                return 'in-development';
            case 'PLANNING':
                return 'coming-soon';
            case 'COMPLETED':
                return 'completed';
            case 'ON_HOLD':
                return 'on-hold';
            default:
                return 'default';
        }
    }

    render() {
        const { title, description, projectStatus, projectUrl, technologies, linkText } = this.props;
        
        return (
            <div className={this.className}>
                <div className="project-header">
                    <h3 className="project-title">{title}</h3>
                    {projectStatus && (
                        <span className={`status-badge ${this.getStatusClass(projectStatus)}`}>
                            {this.formatStatus(projectStatus)}
                        </span>
                    )}
                </div>
                <p className="project-description">{description}</p>
                <div className="tech-tags">
                    {technologies && technologies.map((tech, index) => (
                        <span key={index} className="tech-tag">{tech}</span>
                    ))}
                </div>
                <a href={projectUrl || "#"} className="project-link" target="_blank" rel="noopener noreferrer">
                    {linkText || (projectStatus === 'LIVE' ? 'View Project →' : 
                                 projectStatus === 'IN_DEVELOPMENT' ? 'Coming Soon →' : 
                                 'Learn More →')}
                </a>
            </div>
        )
    }
}

export default ProjectCard;
